import { mount } from 'svelte'
import Waitlist from './pages/Waitlist.svelte'
import './index.css'
import './i18n.js'

// act as const referenced globally
window.isWalletAuthorizeApp = () => false
window.isWalletApp = () => false
window.isWalletInviteApp = () => false

const app = mount(Waitlist, { target: document.body })

export default app
